import { ReactNode } from "react";

// Extend types for more alert types if needed
const ALERT_ICONS = {
  /* (!) */
  error: (
    <span className="flex-shrink-0 h-6 w-6 mr-3 text-red-700">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        focusable="false"
        aria-hidden="true"
        className="block h-full w-full"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 15h-2v-2h2v2Zm0-4h-2V7h2v6Z"
          fill="currentColor"
        />
      </svg>
    </span>
  ),
  /* <none> */
  message: <></>,
  info: <></>,
};

type BoxType = "error" | "message" | "info";

type Props = {
  title?: string;
  message: ReactNode;
  type: BoxType;
  hasIcon?: boolean;
};

const typeCss: Record<BoxType, string> = {
  error:
    "mb-12 p-6 relative shadow-sm bg-pink-50 border flex items-start transition-opacity duration-150",
  message:
    "mb-12 p-6 relative shadow-sm bg-green-50 border flex items-start transition-opacity duration-150",
  info: "mb-12 p-6 relative shadow-sm bg-grey-50 border flex items-start transition-opacity duration-150",
};

export default function AlertBox({
  type,
  title,
  message,
  hasIcon = true,
}: Props) {
  const icon = ALERT_ICONS[type];
  const css = typeCss[type];
  return (
    <div role="alert" id="login-failure-alert" className={css}>
      {hasIcon && <>{icon}</>}
      <div className="flex items-center flex-1">
        <div>
          {title && (
            <div className="font-bold text-[#00262b] text-lg leading-6 mb-2">
              {title}
            </div>
          )}
          <p className="text-gray-700 text-sm leading-6 mb-0">{message}</p>
        </div>
      </div>
    </div>
  );
}
